import { Component, OnInit } from '@angular/core';
import { AuthService } from 'app/auth/auth.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';
import { NivelActionService } from "./nivelAction.service";
import *  as $ from 'jquery';
import * as backInter from 'app/auth/auth-data.model';
import { fuseAnimations } from '@fuse/animations';
import { lang_wizard } from 'app/idiomas/i18n/wizard/wizard.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
// import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';

@Component({
  selector: 'app-version5',
  templateUrl: './nivelAction.component.html',
  styleUrls: ['./nivelAction.component.scss'],
  animations : fuseAnimations
})
export class NivelActionGoComponent implements OnInit {

  idiomaActual:string;
  mailUsuario: string;
  urlSafe: SafeResourceUrl;
  urlEncontrada: boolean;
  productosContratadosInter : backInter.infoProductos;
  idProducto:string;
  busquedaOk: boolean;

  constructor(
    public authService: AuthService,
    public sanitizer: DomSanitizer,
    private translateSrv: TranslateService,
    private ca2Service: NivelActionService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
      // private wizardService: WizardService,
  ) {
    //al cambiar el idioma, se cambia el valor de las variables de idiomas que se usan dentro del codigo
    this.translateSrv.onLangChange.subscribe(() => { this.traduceTextosTS(); });
    lang_wizard.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    this.traduceTextosTS();
  }



  traduceTextosTS(){
    switch(this.translateSrv.currentLang){
      case 'es': case 'zh2': case 'tr': this.idiomaActual = this.translateSrv.currentLang.toUpperCase(); break;
      default: this.idiomaActual = 'EN';
    }
    this.getURLCA();
  }

  //SEGUNDA VERSION
  getURLCA(){
   this.ca2Service.getProductos().subscribe((respuesta:any) => {
      console.log("getProductos:",respuesta);
      let productoCertificar: any;
      respuesta.productosCertificar.forEach(producto => {
        if(producto.idCertificar==localStorage.getItem("productoIDActionGo")){
          console.log("si lo encontro");
          // if(!productoCertificar){
            productoCertificar = producto;
          // }
        }
        // if(producto.idSurvey && producto.tokenConfig){
        //   if(!productoCertificar){
        //     productoCertificar = producto;
        //   }
        // }
      });
      setTimeout(() => {
        this.getURLActionGo(productoCertificar);
      //
    }, 1000);
      }, error => {
      console.log("error", error);
    });
  }

  getURLActionGo(producto:any){
    let datosUsuario = JSON.parse(localStorage.getItem('userData'));
    let datos: any = {
      token: producto.tokenConfig,
      user: datosUsuario.user,
      lang: this.idiomaActual,
      broker: localStorage.getItem('instituto_id'),
      leveluser: datosUsuario.level
    };
    console.log("datosAction:",datos);

    this.ca2Service.getURLACTGO(datos).subscribe((respuesta:any) =>{
      console.log(respuesta);
      if(respuesta.success){
        let urlObtenida = respuesta.url;
        if(localStorage.getItem('levelUser_tmp') == '14'){
          urlObtenida.concat('&ut=4&adm=1');
        }
        this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(urlObtenida);
        this.urlEncontrada = true;
      }
      else{
        console.log("url no encontrada");
        this.urlEncontrada = false;
      }
      this.busquedaOk = true;
    });
  }

}
